import { Dayjs } from 'dayjs'
import { useEffect, useState } from 'react'

export const usePlayer = ({
  step,
  stepUnit,
  interval,
  timeRange: [start, end],
}: {
  step: number
  stepUnit: 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year'
  interval: number
  timeRange: [Dayjs, Dayjs]
}) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const [current, setCurrent] = useState(end)

  useEffect(() => {
    if (!isPlaying) return
    const timer = setInterval(() => {
      setCurrent(current => {
        if (current.isSame(end) || current.isAfter(end)) {
          setIsPlaying(false)
          return current
        }

        const next = current.add(step, stepUnit)
        if (next.isAfter(end)) {
          setIsPlaying(false)
          return end
        }

        return next
      })
    }, interval)
    return () => clearInterval(timer)
  }, [isPlaying, interval, end, step, stepUnit])

  return {
    togglePlay: () => setIsPlaying(v => !v),
    isPlaying,
    current,
    setCurrent,
  }
}
